<h1 mat-dialog-title>
  <div [ngSwitch]="type">
    <mat-icon class="icon-md" color="warn" *ngSwitchCase="dialogType.Warning"
      >warning</mat-icon
    >
    <mat-icon class="icon-md" color="warn" *ngSwitchCase="dialogType.Error"
      >error</mat-icon
    >
    <mat-icon class="icon-md" color="primary" *ngSwitchCase="dialogType.Info"
      >info</mat-icon
    >
    <mat-icon class="icon-md" color="accent" *ngSwitchCase="dialogType.Success"
      >check_circle</mat-icon
    >
    <span *ngSwitchCase="dialogType.None"></span>
    {{ title }}
  </div>
</h1>

<div mat-dialog-content>
  <p *ngIf="data.innerHtml; else normalText" [innerHTML]="data.innerHtml"></p>

  <ng-template #normalText>
    <p class="dialog-message">{{ message }}</p>
  </ng-template>
</div>

<div mat-dialog-actions>
  <button
    [color]="cancelColor"
    *ngIf="variant === dialogVariant.YesNo"
    mat-raised-button
    (click)="onDismiss()"
  >
    {{ noText }}
  </button>
  <button mat-raised-button [color]="confirmColor" (click)="onConfirm()">
    {{ variant === dialogVariant.YesNo ? yesText : "OK" }}
  </button>
</div>
